<!-- チケット名(払い戻し画面) -->
<template>
  <div class="column">
    <!--  チケット名 -->
    <label class="name">{{ $t("common.ticketName") }}</label>

    <div class="value">
      {{ name }}
    </div>
  </div>
</template>

<script>
export default {
  name: "MbTicketNameDisp",
  props: {
    name: {
      type: String,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.column {
  display: flex;
  margin-bottom: 20px;
  font-size: 14px;
}

.column label {
  width: 110px;
  color: #888888;
  display: flex;
  align-items: center;
}

.column .value {
  width: calc(100% - 110px);
  font-weight: bold;
  color: black;
}
</style>
